export const formatIdForDOM = (value: string) => {
  return value.replace(/[^\w]+/g, '');
};
